import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getAssetInspectionCategory as onGetAssetInspectionCategorys, addNewAssetInspectionCategory as onAddNewAssetInspectionCategory, updateAssetInspectionCategory as onUpdateAssetInspectionCategory, deleteAssetInspectionCategory as onDeleteAssetInspectionCategory, getAssetInspectionCategoryLoading, resetAssetInspectionCategoryState } from "../../../store/assetInspectionCategory/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const AssetInspectionCategory = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, companies, companyLoading, assetInspectionCategories, isAssetInspectionCategoryCreated, isAssetInspectionCategorySuccess, loading, error, assetInspectionCategoryLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    assetInspectionCategories: state.AssetInspectionCategory.assetInspectionCategories,
    assetInspectionCategoryLoading: state.AssetInspectionCategory.loading,
    isAssetInspectionCategoryCreated: state.AssetInspectionCategory.isAssetInspectionCategoryCreated,
    isAssetInspectionCategorySuccess: state.AssetInspectionCategory.isAssetInspectionCategorySuccess,
    loading: state.AssetInspectionCategory.loading,
    error: state.AssetInspectionCategory.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [assetInspectionCategory, setAssetInspectionCategory] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [parentList, setParentList] = useState([]);
  const [assetInspectionCategoryList, setAssetInspectionCategoryList] = useState([]);
  const [assetInspectionCategoryName, setAssetInspectionCategoryName] = useState({});
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [positionMessage, setPositionMessage] = useState("");
  const [clientId, setClientId] = useState(0);
  const [printDoc, setPrintDoc] = useState([]);

  const onClickDelete = (assetInspectionCategory) => {
    setAssetInspectionCategory(assetInspectionCategory);
    setDeleteModal(true);
  };

  const handleDeleteAssetInspectionCategory = () => {
    if (assetInspectionCategory) {
      dispatch(onDeleteAssetInspectionCategory(assetInspectionCategory));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (!isEmpty(assetInspectionCategories)) {
      let arr = [];
      assetInspectionCategories.forEach((element) => {
        arr.push({ value: element.id, label: element.asset_inspection_category_name });
      });
      setParentList(arr);
    }
  }, [assetInspectionCategories]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredAssetInspectionCategorys = assetInspectionCategories;
      if (type !== "all") {
        filteredAssetInspectionCategorys = assetInspectionCategories.filter((assetInspectionCategory) => assetInspectionCategory.asset_inspection_category_status.name === type);
      }
      setAssetInspectionCategoryList(filteredAssetInspectionCategorys);
    }
  };

  useEffect(() => {
    setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
    dispatch(resetAssetInspectionCategoryState());
    dispatch(onGetAssetInspectionCategorys());
  }, []);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(assetInspectionCategories)) {
      var data = [];
      var opt = [];
      assetInspectionCategories.forEach((item, key) => {
        const asset_inspection_category_name = item.asset_inspection_category_name;
        const id = item.id;
        var obj = { label: asset_inspection_category_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAssetInspectionCategoryList(data);
    }
  }, [assetInspectionCategories]);

  useEffect(() => {
    if (!isEmpty(assetInspectionCategories)) {
      let filteredAssetInspectionCategorys = assetInspectionCategories;
      if (activeTypeTab !== "all") {
        filteredAssetInspectionCategorys = assetInspectionCategories.filter((assetInspectionCategory) => assetInspectionCategory.asset_inspection_category_status.name === activeTypeTab);
      }
      setAssetInspectionCategoryList(filteredAssetInspectionCategorys.map((el) => ({ ...el, isChecked: false })));
    }
  }, [assetInspectionCategories]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (assetInspectionCategoryList.length > 0) {
      assetInspectionCategoryList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "followup_list_client") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [assetInspectionCategoryList]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleAssetInspectionCategoryClick = useCallback(
    (arg) => {
      const assetInspectionCategory = arg;

      setAssetInspectionCategory({
        id: assetInspectionCategory.id,
        name: assetInspectionCategory.name,
        description: assetInspectionCategory.description,
        client: assetInspectionCategory.asset_inspection_category_client && {
          label: assetInspectionCategory.asset_inspection_category_client ? assetInspectionCategory.asset_inspection_category_client.name : "",
          value: assetInspectionCategory.asset_inspection_category_client ? assetInspectionCategory.asset_inspection_category_client.id : "",
        },
        company: assetInspectionCategory.asset_inspection_category_company && {
          label: assetInspectionCategory.asset_inspection_category_company ? assetInspectionCategory.asset_inspection_category_company.name : "",
          value: assetInspectionCategory.asset_inspection_category_company ? assetInspectionCategory.asset_inspection_category_company.id : "",
        },
        status: assetInspectionCategory.asset_inspection_category_status && {
          label: assetInspectionCategory.asset_inspection_category_status.name,
          value: assetInspectionCategory.asset_inspection_category_status.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      company: (assetInspectionCategory && assetInspectionCategory.company) || companySelected,
      client: (assetInspectionCategory && assetInspectionCategory.client) || clientSelected,
      name: (assetInspectionCategory && assetInspectionCategory.name) ?? "",
      status: assetInspectionCategory && assetInspectionCategory.status,
      description: (assetInspectionCategory && assetInspectionCategory.description) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Silahkan isi kategori temuan aset").nullable(true),
      status: Yup.object().required("Please Select Status"),
    }),
    onSubmit: (values) => {
      dispatch(getAssetInspectionCategoryLoading());
      if (isEdit) {
        const updateAssetInspectionCategory = {
          id: assetInspectionCategory ? assetInspectionCategory.id : 0,
          name: values.name,
          description: values.description,
          statusId: values.status.value,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onUpdateAssetInspectionCategory(updateAssetInspectionCategory));
        validation.resetForm();
      } else {
        const newAssetInspectionCategory = {
          name: values.name,
          description: values.description,
          statusId: values.status.value,
          clientId: values.client.value,
          companyId: values.company.value,
        };
        dispatch(onAddNewAssetInspectionCategory(newAssetInspectionCategory));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteAssetInspectionCategory(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = assetInspectionCategoryList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setAssetInspectionCategoryList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = assetInspectionCategoryList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setAssetInspectionCategoryList(updatedData);
                }}
              />
            </div>
          );
        },
        id: "#",
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateAssetInspectionCategory") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                onClick={() => {
                  const assetInspectionCategoryData = cellProps.row.original;
                  handleAssetInspectionCategoryClick(assetInspectionCategoryData);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Link>
              <Link
                to="#"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deleteAssetInspectionCategory") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                onClick={() => {
                  const assetInspectionCategoryData = cellProps.row.original;
                  onClickDelete(assetInspectionCategoryData);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "asset_inspection_category_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [assetInspectionCategoryList, handleAssetInspectionCategoryClick, userType, userRole, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = assetInspectionCategoryList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setAssetInspectionCategoryList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => assetInspectionCategoryList, [assetInspectionCategoryList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleAssetInspectionCategoryStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetAssetInspectionCategorys(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAssetInspectionCategoryList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetAssetInspectionCategoryState());
    dispatch(onGetAssetInspectionCategorys());
  };

  const handleGetDepartementByAssetInspectionCategory = (assetInspectionCategoryId) => {
    dispatch(onGetAssetInspectionCategorys({ assetInspectionCategoryId: assetInspectionCategoryId }));
  };

  document.title = "Kategori Inspeksi Aset | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={assetInspectionCategoryList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAssetInspectionCategory} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Aset" pageTitle="Kategori Inspeksi Aset" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createAssetInspectionCategory") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteAssetInspectionCategory") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Hapus
            </button> */}
            <ExportDoc data={printDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="assetInspectionCategoryList">
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA INSPEKSI ASET
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "Active");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "Inactive");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                value={statusActive}
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  handleAssetInspectionCategoryStatus(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Kategori Aset Inspeksi" : "Tambah Kategori Aset Inspeksi"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          {/* <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={isDisabledUserType}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("company", "");
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}></Select>
                            {validation.touched.client && validation.errors.client && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.client}
                              </small>
                            )}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading ? (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              ) : (
                                ""
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={companyList.length > 0 ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}></Select>
                            {validation.touched.company && validation.errors.company && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.company}
                              </small>
                            )}
                          </div> */}

                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Grup Usaha
                            </Label>
                            <div className="position-relative">
                              <Select
                                name="client"
                                value={validation.values.client}
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                placeholder="Pilih Grup Usaha"
                                onChange={(e) => {
                                  validation.setFieldValue("client", e);
                                }}
                                options={clientList}
                              ></Select>
                              <div
                                className="position-absolute"
                                style={{
                                  top: "12px",
                                  left: "-24px",
                                }}
                              >
                                {clientLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </div>
                            </div>
                            {validation.touched.client && validation.errors.client ? (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validation.errors.client}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Perusahaan
                            </Label>
                            <div className="position-relative">
                              <Select
                                Select
                                name="company"
                                value={validation.values.company}
                                placeholder="Pilih Perusahaan"
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                onChange={(e) => {
                                  dispatch(setBranchSelect(null));
                                  dispatch(setCompanySelect(e));
                                  validation.setFieldValue("company", e);
                                }}
                                options={companyList}
                              ></Select>
                              <div
                                className="position-absolute"
                                style={{
                                  top: "12px",
                                  left: "-24px",
                                }}
                              >
                                {companyLoading ? (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            {validation.touched.company && validation.errors.company ? (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validation.errors.company}
                              </p>
                            ) : null}
                          </div>
                          {/* //// */}
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="status-field" className="form-label">
                              Status
                            </Label>
                            <Select
                              name="status"
                              value={validation.values.status}
                              validate={{ required: { value: true } }}
                              placeholder="Pilih Status"
                              onChange={(e) => {
                                validation.setFieldValue("status", e);
                              }}
                              onInputChange={(e) => {
                                // handleUnit(e);
                              }}
                              options={statusActiveData}
                              invalid={validation.touched.status && validation.errors.status ? true : false}
                            ></Select>
                            {validation.touched.status && validation.errors.status && (
                              <p className="text-danger" type="invalid">
                                {validation.errors.status}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" rows={6} placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            dispatch(onGetAssetInspectionCategorys({ status: 1 }));
                            validation.resetForm();
                          }}
                        >
                          Batal
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AssetInspectionCategory;
